export class Constant {
    id: string;
    phoneString: string;
    name: string;
}
